module.exports = __webpack_public_path__ + "img/official-6.0699d80d.png";